import { FC, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { buildUrl } from 'utilities/strings';

const RedirectToDashboard: FC = () => {
  const location = useLocation();
  const url = useMemo(() => buildUrl('Root.children.AudienceBuilder.children.Build.path'), []);
  // const url = useMemo(() => buildUrl('Root.children.Dashboard'), []);

  return (
    <Navigate
      replace
      state={{ from: location }}
      to={url}
    />
  );
};

export default RedirectToDashboard;
